import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import ScheduleIcon from "@mui/icons-material/Schedule";
import SouthIcon from "@mui/icons-material/South";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { Button } from "../../../components/button/Button";
import { formatRecoveryCode } from "./recoveryCode";

// Client-side intro (§12.1): time expectation, negative-first framing, the facilitator
// disclosure, and the resume code - four one-line jobs, then Start. No backend step.
const TopikIntroView = ({ t, session, onStart }) => {
  const recoveryCode = formatRecoveryCode(session.recoveryCode);

  return (
    <>
      <Helmet>
        <meta name="theme-color" content="#222222" />
        <html className="card-background" />
      </Helmet>
      <motion.main
        className="topik-view topik-intro-view"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="topik-view__title">{t("topik-intro-view.title")}</h1>
        <p className="topik-view__instruction">{t("topik-intro-view.lead")}</p>

        <ul className="topik-intro-view__points">
          <li className="topik-intro-view__point">
            <ScheduleIcon className="topik-intro-view__point-icon" aria-hidden="true" />
            <span>{t("topik-intro-view.time")}</span>
          </li>
          <li className="topik-intro-view__point">
            <SouthIcon className="topik-intro-view__point-icon" aria-hidden="true" />
            <span>{t("topik-intro-view.framing")}</span>
          </li>
          <li className="topik-intro-view__point">
            <VisibilityIcon className="topik-intro-view__point-icon" aria-hidden="true" />
            <span>{t("topik-intro-view.disclosure")}</span>
          </li>
        </ul>

        {recoveryCode && (
          <div className="topik-intro-view__resume">
            <span className="topik-intro-view__resume-label">{t("topik-intro-view.resume-label")}</span>
            <span className="topik-intro-view__resume-code">{recoveryCode}</span>
          </div>
        )}

        <Button
          extendClassName="topik-intro-view__start"
          content={t("topik-intro-view.start")}
          onClick={onStart}
        />
      </motion.main>
    </>
  );
};

TopikIntroView.propTypes = {
  t: PropTypes.func.isRequired,
  session: PropTypes.shape({
    recoveryCode: PropTypes.string,
  }).isRequired,
  onStart: PropTypes.func.isRequired,
};

export default withTranslation("views")(TopikIntroView);
